import { useNavigate } from "react-router";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { Adjunto, CompraTerrenoDetalle, PagoCompraTerreno } from "@/lib/api";
import { rolesDe } from "@/lib/navegacion";

/** La compra del terreno vista como gasto (sin JSX): sólo lectura; los pagos a cuenta se cargan desde Terreno. */
export function useCompraTerrenoTab() {
  const { fid, membresia } = useContextoApp();
  const navegar = useNavigate();
  const ficha = useApiResource<CompraTerrenoDetalle>(`/api/fideicomisos/${fid}/gastos/compra-terreno`);

  return {
    cargando: ficha.loading && !ficha.data,
    errorCarga: ficha.data ? null : (ficha.error?.message ?? null),
    compra: ficha.data ?? null,
    esAdmin: membresia.rol === "admin",
    // el fiduciante no entra a Terreno (docs/modulo-portal.md § 4)
    veTerreno: rolesDe("/terreno").includes(membresia.rol),
    rutaDescarga: (a: Adjunto) => `/api/fideicomisos/${fid}/adjuntos/${a.id}/descarga`,
    verPago: (p: PagoCompraTerreno) => void navegar(`/gastos/${p.gasto_id}`),
  };
}
